import React from 'react';
import classnames from 'classnames';
export function VideoCard ( { title, description, iframe, tags, sidebar, tagColors, onClick, small, className }: any ) {

    let tagsFiltered = null;
    if (sidebar) {
        tagsFiltered = tags.filter((tag: any) => tag !== 'Suggested');
    } else {
        tagsFiltered = tags;
    }

    let baseClass = !small ? 'itc-video' : 'itc-video-small';

    let videoCardClass = classnames(baseClass, className);

    if (description?.length >= 120) {
        description = description.slice(0, 117) + '...';
    }

    let titleConcat = title;

    if (titleConcat?.length >= 42 && !small) {
        titleConcat = titleConcat.slice(0, 39) + '...';
    }

    if (titleConcat?.length >= 42 && small) {
        titleConcat = titleConcat.slice(0, 45) + '...';
    }

    return (
        <div className={videoCardClass + '__card'} onClick={onClick}>
            <div className={videoCardClass + '__iframe'} dangerouslySetInnerHTML={iframe}></div>
            <div className={videoCardClass + '__info'}>
                { sidebar && !small && <div className={videoCardClass + '__tag-box'}>
                    { tagsFiltered?.map((tag: any, index: any) => {
                        return (
                            <span key={index} className={videoCardClass + '__tag itc-video__tag--' + tagColors[tag]}>{tag}</span>);
                    })
                    }
                </div>
                }
                <span className={videoCardClass + '__title'}>{ titleConcat }</span>
                <span className={videoCardClass + '__description'}>{description}</span>
            </div>
        </div>
    );
}

VideoCard.defaultProps = {
    small: false,
};